import type { ReactElement, ReactNode } from 'react';
import { InboxOutlined } from '@ant-design/icons';

export function EmptyState({
  text,
  action,
  icon = <InboxOutlined />,
}: {
  text: string;
  action?: ReactNode;
  icon?: ReactNode;
}): ReactElement {
  return (
    <div className="entity-empty-state">
      {icon}
      <span>{text}</span>
      {action}
    </div>
  );
}
